module.exports = __webpack_public_path__ + "img/221-75ec01.png";